import { render, staticRenderFns } from "./SubZonesList.vue?vue&type=template&id=1daf30fa&scoped=true&"
import script from "./SubZonesList.vue?vue&type=script&lang=js&"
export * from "./SubZonesList.vue?vue&type=script&lang=js&"
import style0 from "./SubZonesList.vue?vue&type=style&index=0&id=1daf30fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf30fa",
  null
  
)

export default component.exports